import React from "react";
import "./VSL.css";

const VSL = () => {
  return (
    <section className="hermes-section">
      <div className="hermes-container">
        <div className="hermes-grid" data-aos="fade-up">
          <div className="hermes-video-wrapper">
            <div className="video-container">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/j5cShW-hf2A?autoplay=1&mute=1&loop=1&playlist=j5cShW-hf2A"
                title="VSL Hermes"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
            </div>
          </div>
          <div className="hermes-text">
            <h2 className="hermes-title">
              Na mitologia grega, Hermes era o mensageiro dos deuses.
            </h2>
            <p className="hermes-paragraph">
              Mas ele não era apenas um entregador de recados.
            </p>
            <p className="hermes-paragraph">
              Era quem sabia <strong>onde, como e quando</strong> a mensagem
              precisava chegar.
            </p>
            <p className="hermes-paragraph">
              Era <strong>estratégia</strong>. <strong>Precisão</strong>.{" "}
              <strong>Velocidade</strong>. <strong>Resultado</strong>.
            </p>
            <p className="hermes-paragraph">
              Hoje, o que falta a muitos consultórios não é{" "}
              <strong>competência técnica</strong>.<br />É{" "}
              <span className="highlight">inteligência comercial</span>.
            </p>
            <p className="hermes-paragraph">
              A mensagem certa está sendo enviada…
              <br />
              Mas <em>da maneira errada</em>.<br />
              <em>No tempo errado</em>.<br />
              <em>Para a pessoa errada</em>.
            </p>
            <p className="hermes-paragraph final">E isso custa caro.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VSL;
